import axios from "axios";
import { processFormula } from "./namespace";
import { response } from "../../lib/utils";
import { IResponse } from "../../types";

export async function getAllFormulas(formulaContext: string,prompt:string): Promise<IResponse> {
    try {
        const res = await axios.post(processFormula, {
            data: formulaContext,
            prompt: prompt
        });
        if (!res.data) {
            return response(false, "No data found", null);
        }

        return response(true, "Data found", res.data[0].output);
    } catch (error: any) {
        throw new Error(error);
    }
}